import React, { useEffect, useState } from "react";
import ChiTietHopDongApi from "service/chiTietHopDongApi";
import CauHinhThongKeKhachHangApi from "service/CauHinhThongKeKhachHangApi";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import cauHinh from "utils/cauHinh";

const DANH_SACH_O = [
  { ten: "NgheNghiepId", nhan: "Nghề nghiệp", loai: "nghenghiep" },
  { ten: "KhuVucId", nhan: "Khu vực", loai: "khuvuc" },
  { ten: "HinhThucVayId", nhan: "Hình thức vay", loai: "hinhthucvay" },
  { ten: "NguonKhId", nhan: "Nguồn khách hàng", loai: "nguonkhach" },
];

const GIA_TRI_TRONG = {
  NgheNghiepId: "",
  KhuVucId: "",
  HinhThucVayId: "",
  NguonKhId: "",
};

const laBatCauHinh = (value) =>
  value === true ||
  value === 1 ||
  value === "1" ||
  value === "True" ||
  value === "true";

const veChuoi = (value) =>
  value === null || value === undefined ? "" : String(value);

// Nguồn khách hàng / Nghề nghiệp / Khu vực / Hình thức vay lưu theo hợp đồng, chỉ công ty bật isMoney88.
// Ô hidden đặt tên không tiền tố nên lên payload thành ChoVay.NgheNghiepId...
// khoa: hợp đồng đã phát sinh giao dịch (IsEditChoVay của form) thì không cho sửa.
const ThuocTinhThongKeHopDong = ({ currentForm, choVayId, khoa }) => {
  const [isMoney88, setIsMoney88] = useState(false);
  const [combo, setCombo] = useState({});
  const [giaTri, setGiaTri] = useState(GIA_TRI_TRONG);

  useEffect(() => {
    let daHuy = false;
    ConfigSystemApi.GetConfigSystemByKeyConfig({ key: cauHinh.sKey.IsMoney88 })
      .then((res) => {
        if (daHuy || !laBatCauHinh(res.data)) return;
        setIsMoney88(true);
        DANH_SACH_O.forEach(({ ten, loai }) =>
          CauHinhThongKeKhachHangApi.danhSach({ loai })
            .then((r) => {
              if (daHuy) return;
              setCombo((cu) => ({
                ...cu,
                [ten]: (r.data || []).map((item) => ({
                  value: String(item.Id),
                  label: item.Ten,
                  isActive: item.IsActive,
                })),
              }));
            })
            .catch(() => {}),
        );
      })
      .catch(() => {});
    return () => {
      daHuy = true;
    };
  }, []);

  // Sửa / sao chép hợp đồng: nạp giá trị của hợp đồng (hợp đồng cũ chưa có thì backend lấy theo khách)
  useEffect(() => {
    setGiaTri(GIA_TRI_TRONG);
    if (!isMoney88 || !(choVayId > 0)) return;
    let daHuy = false;
    ChiTietHopDongApi.thuocTinhThongKeHopDong(choVayId).then((res) => {
      if (daHuy || res.status !== 200 || !res.data) return;
      setGiaTri({
        NgheNghiepId: veChuoi(res.data.NgheNghiepId),
        KhuVucId: veChuoi(res.data.KhuVucId),
        HinhThucVayId: veChuoi(res.data.HinhThucVayId),
        NguonKhId: veChuoi(res.data.NguonKhId),
      });
    });
    return () => {
      daHuy = true;
    };
  }, [isMoney88, choVayId]);

  if (!isMoney88) return null;

  const { register, errors, setValue } = currentForm;
  // Không register thẳng select: react-hook-form gắn listener change lên DOM, re-render lúc xóa lỗi
  // kéo select về giá trị cũ nên lần chọn đầu không ăn. Field của form là ô hidden đi kèm.
  const onChange = (ten) => (event) => {
    const value = event.target.value;
    setGiaTri((cu) => ({ ...cu, [ten]: value }));
    setValue(ten, value, { shouldValidate: true });
  };

  // Dòng đầu card "Thông tin cho vay": trên 10px như các ô cùng card (.thongtinchovay-v2 .col-md-4 { margin-top: 10px }),
  // dưới thêm 10px vì ô kế tiếp ở form trả góp không có margin-top
  return (
    <div className="col-md-12" style={{ marginBottom: "10px" }}>
      <div className="row">
        {DANH_SACH_O.map(({ ten, nhan }) => (
          <div className="col-md-3" key={ten} style={{ marginTop: "10px" }}>
            <label className="label-control color7-bold">
              {nhan} <span className="canh-bao-red">*</span>
            </label>
            <select
              className="form-control input-sm select-v2"
              value={giaTri[ten]}
              onChange={onChange(ten)}
              disabled={khoa}
              title={khoa ? "Hợp đồng đã phát sinh giao dịch" : undefined}
            >
              <option value="">-- Chọn {nhan.toLowerCase()} --</option>
              {/* Mục đã khóa không cho chọn mới nhưng vẫn giữ giá trị hợp đồng đang gắn */}
              {(combo[ten] || [])
                .filter(
                  (item) => item.isActive !== 0 || item.value === giaTri[ten],
                )
                .map((item) => (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                ))}
            </select>
            {/* Khóa thì bỏ bắt buộc để HĐ cũ thiếu giá trị vẫn lưu được phần khác. Phải ghi rõ
                required: false vì react-hook-form v6 gộp rule cũ khi register lại cùng ô */}
            <input
              type="hidden"
              name={ten}
              value={giaTri[ten]}
              ref={register({
                required: khoa ? false : "Hãy chọn " + nhan.toLowerCase(),
              })}
            />
            <span className="canh-bao-red">
              {errors && errors[ten] && errors[ten].message}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThuocTinhThongKeHopDong;
